import { NavConfig } from '@/types/header'
import { Star } from 'lucide-react'

export const navConfig: NavConfig = {
  'nav.category.male': {
    type: 'male',
    href: '/nam',
    sections: [
      {
        title: 'nav.section.all_products',
        href: '/collection/do-nam',
        items: [
          {
            title: 'nav.item.new_product',
            href: '/collection/san-pham-moi?gender_type=MALE',
            className: 'text-primary font-semibold',
          },
          // {
          //   title: 'nav.item.goodPrice',
          //   href: '/collection/gia-tot-nhat',
          //   className: 'font-semibold text-secondary hover:text-primary-500',
          // },
          {
            title: 'nav.item.best_seller',
            href: '/collection/ban-chay-nhat?gender_type=MALE',
            className: 'font-semibold text-neutral-900 hover:text-primary-500',
          },
          {
            title: 'nav.item.ecc_collection',
            href: '/collection/ecc-collection',
          },
          { title: 'nav.item.excool_collection', href: '/collection/excool' },
          {
            title: 'nav.item.copper_denim',
            href: '/collection/copper-denim',
          },
          {
            title: 'nav.item.promax',
            href: '/collection/ldp-promax?itm_source=navbar',
          },
        ],
      },
      {
        title: 'nav.section.male_shirts',
        href: '/collection/ao-nam',
        items: [
          {
            title: 'nav.item.male_tanktop',
            href: '/collection/ao-ba-lo-tank-top-nam',
          },
          { title: 'nav.item.male_tshirt', href: '/collection/ao-thun-nam' },
          {
            title: 'nav.item.male_sport_shirt',
            href: '/collection/ao-nam-choi-the-thao',
          },
          { title: 'nav.item.male_polo', href: '/collection/ao-polo-nam' },
          { title: 'nav.item.male_shirt', href: '/collection/ao-so-mi-nam' },
          {
            title: 'nav.item.male_long_sleeve',
            href: '/collection/ao-nam-dai-tay',
          },
          { title: 'nav.item.male_jacket', href: '/collection/ao-khoac-nam' },
          {
            title: 'nav.item.male_graphic_tee',
            href: '/graphic-tee?itm_source=navbar',
          },
        ],
      },
      {
        title: 'nav.section.male_pants',
        href: '/collection/quan-nam',
        items: [
          // { title: 'nav.item.malePants', href: '/collection/quan-nam' },
          { title: 'nav.item.male_shorts', href: '/collection/quan-short-nam' },
          {
            title: 'nav.item.male_jogger',
            href: '/collection/quan-jogger-nam',
          },
          {
            title: 'nav.item.male_sport_pants',
            href: '/collection/quan-nam-choi-the-thao',
          },
          {
            title: 'nav.item.male_long_pants',
            href: '/collection/quan-dai-nam',
          },
          { title: 'nav.item.male_pants', href: '/collection/quan-pants-nam' },
          { title: 'nav.item.male_jeans', href: '/collection/quan-jeans-nam' },
          { title: 'nav.item.male_kaki', href: '/collection/quan-kaki-nam' },
          { title: 'nav.item.male_swimwear', href: '/collection/do-boi-nam' },
        ],
      },
      {
        title: 'nav.section.male_underwear',
        href: '/collection/quan-lot-nam',
        items: [
          // { title: 'nav.item.maleUnderwear', href: '/collection/quan-lot-nam' },
          {
            title: 'nav.item.brief',
            href: '/collection/quan-lot-nam-brief-tam-giac',
          },
          {
            title: 'nav.item.trunk',
            href: '/collection/quan-lot-nam-boxer-trunk',
          },
          {
            title: 'nav.item.boxer_brief',
            href: '/collection/quan-lot-nam-brief-boxer-dang-dai',
          },
          {
            title: 'nav.item.long_leg',
            href: '/collection/quan-lot-nam-long-leg',
          },
          {
            title: 'nav.item.home_short',
            href: '/collection/quan-short-nam-mac-o-nha',
          },
        ],
      },
      {
        title: 'nav.section.male_accessories',
        href: '/collection/phu-kien-nam',
        items: [
          {
            title: 'nav.item.all_accessories',
            description: '(Tất, mũ, túi...)',
            href: '/collection/phu-kien-nam',
          },
        ],
      },
    ],
    featured: [
      {
        title: 'nav.featured.generation_v',
        href: '/product/ao-thun-chay-bo-viet-nam-tien-buoc',
        imageAlt: 'nav.featured.generation_v_male',
        imageSrc: '/image/August2025/mceclip7.jpg',
      },
      {
        title: 'nav.featured.pickleball_male',
        href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nam',
        imageAlt: 'nav.featured.pickleballMale',
        imageSrc: '/image/June2025/mceclip9_63.jpg',
      },
    ],
    footer: [
      {
        title: 'nav.footer.by_need',
        items: [
          {
            title: 'nav.footer.underwear',
            href: '/collection/quan-lot-nam',
          },
          {
            title: 'nav.footer.sport',
            href: '/collection/coolmate-activewear',
          },
          {
            title: 'nav.footer.casual',
            href: '/collection/do-casual',
          },
          {
            title: 'nav.footer.graphic_tee',
            href: '/graphic-tee',
          },
        ],
      },
    ],
    // mobileBanner: {
    //   title: 'Quần Dài Nam Kaki Excool',
    //   href: '/products/quan-dai-kaki-excool',
    //   imageAlt: 'sadasd',
    //   imageSrc:
    //     'https://media3.coolmate.me/uploads/March2025/mceclip24.png',
    // },
  },
  'nav.category.female': {
    type: 'female',
    href: '/nu',
    sections: [
      {
        title: 'nav.section.female_all_products',
        href: '/collection/coolmate-activewear-nu',
        items: [
          {
            title: 'nav.item.new_product',
            href: '/collection/san-pham-moi?gender_type=FEMALE',
            className: 'text-primary font-semibold',
          },
          {
            title: 'nav.item.female_running',
            href: '/collection/quan-ao-chay-bo-nu',
          },
          {
            title: 'nav.item.female_general_sport',
            href: '/collection/the-thao-chung-nu',
          },
          {
            title: 'nav.item.female_pickleball',
            href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nu&itm_source=navbar',
          },
        ],
      },
      {
        title: 'nav.section.female_shirts',
        href: '/collection/ao-nu',
        items: [
          { title: 'nav.item.female_sport_bra', href: '/collection/ao-bra-nu' },
          {
            title: 'nav.item.female_croptop',
            href: '/collection/ao-cropped-top',
          },
          { title: 'nav.item.female_polo', href: '/collection/ao-polo-nu' },
          {
            title: 'nav.item.female_singlet',
            href: '/collection/ao-singlet-nu',
          },
          { title: 'nav.item.female_tshirt', href: '/collection/ao-thun-nu' },
          {
            title: 'nav.item.female_graphic_tee',
            href: '/graphic-tee?itm_source=navbar',
          },
        ],
      },
      {
        title: 'nav.section.female_pants',
        href: '/collection/quan-nu',
        items: [
          {
            title: 'nav.item.female_legging',
            href: '/collection/quan-legging',
          },
          {
            title: 'nav.item.female_shorts',
            href: '/collection/quan-short-nu',
          },
          {
            title: 'nav.item.female_biker_shorts',
            href: '/collection/quan-biker-short',
          },
          { title: 'nav.item.female_dress', href: '/collection/vay-dam-nu' },
        ],
      },
      {
        title: 'nav.section.female_accessories',
        href: '/collection/phu-kien-nu',
        items: [
          {
            title: 'nav.item.female_all_accessories',
            description: '(Tất, mũ, túi...)',
            href: '/collection/phu-kien-nu',
          },
        ],
      },
      {
        title: 'nav.section.explore',
        href: '',
        items: [
          {
            title: 'nav.item.female_guide_size',
            href: '/huong-dan-chon-size-do-nu',
          },
          {
            title: 'nav.item.female_ambassador',
            href: '/dai-su-the-thao?active-tab=sports-ambassador',
          },
          {
            title: 'nav.item.female_club',
            href: '/dai-su-the-thao?active-tab=club-sports-ambassador',
          },
        ],
      },
    ],
    featured: [
      {
        title: 'nav.featured.generation_v',
        href: '/product/ao-thun-chay-bo-viet-nam-tien-buoc',
        imageAlt: 'nav.featured.generation_v_female',
        imageSrc: '/image/August2025/mceclip7.jpg',
      },
      {
        title: 'nav.featured.pickleball_female',
        href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nu',
        imageAlt: 'nav.featured.pickleballFemale',
        imageSrc: '/image/June2025/mceclip10_41.jpg',
      },
    ],
    footer: [
      {
        title: 'nav.footer.by_need',
        items: [
          {
            title: 'nav.footer.running',
            href: '/collection/quan-ao-chay-bo-nu',
          },
          {
            title: 'nav.footer.bra_legging',
            href: '/collection/bra-legging-collection',
          },
          {
            title: 'nav.footer.yoga_pilates',
            href: '/collection/yoga-pilates',
          },
          {
            title: 'nav.footer.pickleball',
            href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nu',
          },
          {
            title: 'nav.footer.graphic_tee',
            href: '/graphic-tee',
          },
        ],
      },
    ],
  },
}

export const navConfigCollection = {
  'nav.section.sport': {
    type: 'sport',
    href: '/collection/coolmate-activewear',
    sections: [
      {
        title: 'nav.section.sport_male',
        href: '/collection/coolmate-activewear',
        items: [
          {
            title: 'nav.item.female_general_sport',
            href: '/collection/the-thao-chung-nam',
            img: '/image/March2025/mceclip22.png',
          },
          {
            title: 'nav.item.female_running',
            href: '/collection/quan-ao-chay-bo',
            img: '/image/March2025/mceclip18_32.png',
          },
          {
            title: 'nav.item.gym',
            href: '/collection/quan-ao-phu-kien-tap-gym',
            img: '/image/March2025/mceclip19_2.png',
          },
          {
            title: 'nav.item.football',
            href: '/collection/quan-ao-da-bong-coolmate',
            img: '/image/March2025/mceclip16.png',
          },
          {
            title: 'nav.item.male_swimwear',
            href: '/collection/do-boi-nam',
            img: '/image/March2025/mceclip15.png',
          },
          {
            title: 'nav.item.female_badminton',
            href: '/collection/racquet-sports-collection',
            img: '/image/March2025/mceclip17_87.png',
          },
          {
            title: 'nav.item.female_pickleball',
            href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nam',
            img: '/image/June2025/mceclip7.png',
          },
          {
            title: 'nav.item.outdoor',
            href: '/collection/outdoor-collection',
            img: '/image/August2024/mceclip0_18.jpg',
          },
        ],
      },
      {
        title: 'nav.section.sport_female',
        href: '/collection/coolmate-activewear-nu',
        items: [
          {
            title: 'nav.item.female_yoga',
            href: '/collection/yoga-pilates',
            img: '/image/March2025/mceclip14.png',
          },
          {
            title: 'nav.item.female_sport_shirt',
            href: '/collection/ao-nu-choi-the-thao',
            img: '/image/March2025/mceclip9_28.png',
          },
          {
            title: 'nav.item.female_running',
            href: '/collection/quan-ao-chay-bo-nu',
            img: '/image/March2025/mceclip10_72.png',
          },
          {
            title: 'nav.item.female_sport_pants',
            href: '/collection/quan-nu-choi-the-thao',
            img: '/image/March2025/mceclip12_6.png',
          },
          {
            title: 'nav.item.female_general_sport',
            href: '/collection/the-thao-chung-nu',
            img: '/image/March2025/mceclip13_73.png',
          },
          {
            title: 'nav.item.female_sport_accessories',
            href: '/collection/phu-kien-nu-choi-the-thao',
            img: '/image/March2025/mceclip11_21.png',
          },
          {
            title: 'nav.item.female_pickleball',
            href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nu',
            img: '/image/June2025/mceclip6_7.png',
          },
        ],
      },
    ],
    featured: [
      {
        title: 'nav.featured.pickleball_and_tennis',
        href: '/collection/pickleball-tennis',
        imageAlt: 'nav.featured.pickleballAndTennis',
        imageSrc: '/image/June2025/mceclip11_92.jpg',
      },
      {
        title: 'nav.featured.sport_shorts_male_promax_s1',
        href: '/product/quan-the-thao-nam-promax-s1?color=den',
        imageAlt: 'nav.featured.sportShortsMalePromaxS1',
        imageSrc: '/image/April2025/mceclip4_98.jpg',
      },
    ],
  },
}

export const navConfigCareAndShare = {
  type: 'care_and_share',
  title: 'nav.care_and_share.title',
  description: 'nav.care_and_share.description',
  imageStep: '/image/September2024/mceclip7_1.png',
  href: '/collection/care-and-share',
  image: '/image/March2025/mceclip0_226.jpg',
  imageMobile: '/image/February2025/mceclip0_55.png',
  buttonText: 'nav.care_and_share.title',
  specialCollections: [
    {
      title: 'nav.care_and_share.ao_am_cho_em',
      href: '/collection/ao-am-cho-em',
      img: '/image/October2024/mceclip0_9.png',
    },
    {
      title: 'nav.care_and_share.vun_art',
      href: '/collection/vun-art-du-an-chung-tay-xay-nha-moi',
      img: '/image/July2024/mceclip0_156.jpg',
    },
    {
      title: 'nav.care_and_share.cung_hoang_dao',
      href: '/collection/cung-hoang-dao-collection',
      img: '/image/May2024/mceclip2_33.png',
    },
  ],
}

export const menuMobileConfig = {
  menu: {
    'nav.category.male': {
      type: 'male',
      button: {
        text: 'nav.mobile.explore_male',
        href: '/nam',
      },
      sections: [
        {
          title: 'nav.section.highlight',
          items: [
            { title: 'nav.section.all_products', href: '/collection/do-nam' },
            {
              title: 'nav.item.new_product',
              href: '/collection/san-pham-moi?gender_type=MALE',
              className: 'text-primary',
            },
            {
              title: 'nav.item.best_seller',
              href: '/collection/ban-chay-nhat?gender_type=MALE',
              className: 'text-neutral-900',
            },
            {
              title: 'nav.item.ecc_collection',
              href: '/collection/ecc-collection',
            },
            { title: 'nav.item.excool_collection', href: '/collection/excool' },
            {
              title: 'nav.item.copper_denim',
              href: '/collection/copper-denim',
            },
            { title: 'nav.item.promax', href: '/collection/ldp-promax' },
            {
              title: 'nav.item.outlet',
              href: '/collection/giam-gia?gender_type=male',
              className: 'text-error-500',
            },
          ],
        },
        {
          title: 'nav.section.male_shirts',
          items: [
            { title: 'nav.item.all_male_shirts', href: '/collection/ao-nam' },
            {
              title: 'nav.item.male_tanktop',
              href: '/collection/ao-ba-lo-tank-top-nam',
            },
            { title: 'nav.item.male_tshirt', href: '/collection/ao-thun-nam' },
            {
              title: 'nav.item.male_sport_shirt',
              href: '/collection/ao-nam-choi-the-thao',
            },
            { title: 'nav.item.male_polo', href: '/collection/ao-polo-nam' },
            { title: 'nav.item.male_shirt', href: '/collection/ao-so-mi-nam' },
            {
              title: 'nav.item.male_long_sleeve',
              href: '/collection/ao-nam-dai-tay',
            },
            { title: 'nav.item.male_jacket', href: '/collection/ao-khoac-nam' },
            { title: 'nav.item.male_graphic_tee', href: '/graphic-tee' },
          ],
        },
        {
          title: 'nav.section.male_pants',
          items: [
            { title: 'nav.item.all_male_pants', href: '/collection/quan-nam' },
            {
              title: 'nav.item.male_shorts',
              href: '/collection/quan-short-nam',
            },
            {
              title: 'nav.item.male_jogger',
              href: '/collection/quan-jogger-nam',
            },
            {
              title: 'nav.item.male_sport_pants',
              href: '/collection/quan-nam-choi-the-thao',
            },
            {
              title: 'nav.item.male_long_pants',
              href: '/collection/quan-dai-nam',
            },
            {
              title: 'nav.item.male_jeans',
              href: '/collection/quan-jeans-nam',
            },
            {
              title: 'nav.item.male_kaki',
              href: '/collection/quan-kaki-nam',
            },
            { title: 'nav.item.male_swimwear', href: '/collection/do-boi-nam' },
          ],
        },
        {
          title: 'nav.section.male_underwear',
          items: [
            {
              title: 'nav.item.all_male_underwear',
              href: '/collection/quan-lot-nam',
            },
            {
              title: 'nav.item.brief',
              href: '/collection/quan-lot-nam-brief-tam-giac',
            },
            {
              title: 'nav.item.trunk',
              href: '/collection/quan-lot-nam-boxer-trunk',
            },
            {
              title: 'nav.item.boxer_brief',
              href: '/collection/quan-lot-nam-brief-boxer-dang-dai',
            },
            {
              title: 'nav.item.long_leg',
              href: '/collection/quan-lot-nam-long-leg',
            },
            {
              title: 'nav.item.home_short',
              href: '/collection/quan-lot-nam-boxer-shorts',
            },
          ],
        },
        {
          title: 'nav.section.male_accessories',
          items: [
            {
              title: 'nav.item.all_accessories',
              subtitle: '(Tất, mũ, túi...)',
              href: '/collection/phu-kien-nam',
            },
          ],
        },
      ],
      featured: [
        {
          title: 'nav.featured.generation_v',
          href: '/product/ao-thun-chay-bo-viet-nam-tien-buoc',
          imageAlt: 'nav.featured.generation_v_male',
          imageSrc: '/image/August2025/mceclip9.jpg',
        },
        {
          title: 'nav.item.male_shirt',
          href: '/product/ao-so-mi-essentials-100-cotton-dai-tay-mem-mai2?color=trang',
          imageAlt: 'nav.item.maleShirt',
          imageSrc: '/image/March2025/mceclip24.png',
        },
        {
          title: 'nav.item.male_jogger',
          href: '/product/quan-jeans-nam-dang-straight-sieu-nhe?color=xanh-wash',
          imageAlt: 'nav.item.maleJogger',
          imageSrc: '/image/March2025/mceclip23.png',
        },
      ],
    },
    'nav.category.female': {
      type: 'female',
      button: {
        text: 'nav.mobile.explore_female',
        href: '/nu',
      },
      sections: [
        {
          title: 'nav.section.highlight',
          items: [
            {
              title: 'nav.section.female_all_products',
              href: '/collection/coolmate-activewear-nu',
            },
            {
              title: 'nav.item.new_product',
              href: '/collection/san-pham-moi?gender_type=FEMALE',
              className: 'text-primary',
            },
            {
              title: 'nav.item.female_running',
              href: '/collection/quan-ao-chay-bo-nu',
            },
            {
              title: 'nav.item.female_bra_legging',
              href: '/collection/bra-legging-collection',
            },
            { title: 'nav.item.female_yoga', href: '/collection/yoga-pilates' },
            {
              title: 'nav.item.female_general_sport',
              href: '/collection/the-thao-chung-nu',
            },
            {
              title: 'nav.item.female_pickleball',
              href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nu',
            },
            // {
            //   title: 'nav.item.female_badminton',
            //   href: '/collection/cau-long-bong-ban-nu',
            //   isComingSoon: true,
            // },
            {
              title: 'nav.item.outlet_30',
              href: '/collection/giam-gia?gender_type=female',
              className: 'text-error-500',
            },
          ],
        },
        {
          title: 'nav.section.female_shirts',
          items: [
            { title: 'nav.item.female_all_shirts', href: '/collection/ao-nu' },
            {
              title: 'nav.item.female_sport_bra',
              href: '/collection/ao-bra-nu',
            },
            {
              title: 'nav.item.female_croptop',
              href: '/collection/ao-cropped-top',
            },
            {
              title: 'nav.item.female_singlet',
              href: '/collection/ao-singlet-nu',
            },
            { title: 'nav.item.female_tshirt', href: '/collection/ao-thun-nu' },
            { title: 'nav.item.female_graphic_tee', href: '/graphic-tee' },
          ],
        },
        {
          title: 'nav.section.female_pants',
          items: [
            { title: 'nav.item.female_all_pants', href: '/collection/quan-nu' },
            {
              title: 'nav.item.female_legging',
              href: '/collection/quan-legging',
            },
            {
              title: 'nav.item.female_shorts',
              href: '/collection/quan-short-nu',
            },
            {
              title: 'nav.item.female_biker_shorts',
              href: '/collection/quan-biker-short',
            },
          ],
        },
        {
          title: 'nav.section.female_accessories',
          items: [
            {
              title: 'nav.item.female_all_accessories',
              subtitle: '(Tất, mũ, túi...)',
              href: '/collection/phu-kien-nu',
            },
          ],
        },
        {
          title: 'nav.section.explore',
          items: [
            {
              title: 'nav.item.female_guide_size',
              href: '/huong-dan-chon-size-do-nu',
            },
            {
              title: 'nav.item.female_ambassador',
              href: '/dai-su-the-thao?active-tab=sports-ambassador',
            },
            {
              title: 'nav.item.female_club',
              href: '/dai-su-the-thao?active-tab=club-sports-ambassador',
            },
          ],
        },
      ],
      featured: [
        {
          title: 'nav.featured.generation_v',
          href: '/product/ao-thun-chay-bo-viet-nam-tien-buoc',
          imageAlt: 'nav.featured.generation_v_female',
          imageSrc: '/image/August2025/mceclip9.jpg',
        },
        {
          title: 'nav.featured.coolmate_active_for_women',
          href: '/collection/coolmate-activewear-nu',
          imageAlt: 'nav.featured.coolmateActiveForWomen',
          imageSrc: '/image/March2025/mceclip30.png',
        },
        {
          title: 'nav.featured.legging_yoga_ribbed',
          href: '/collection/bra-legging-collection',
          imageAlt: 'nav.featured.leggingYogaRibbed',
          imageSrc: '/image/July2025/mceclip5_40.png',
        },
      ],
    },
    'nav.section.sport': {
      type: 'sport',
      button: undefined,
      sections: [
        {
          title: 'nav.section.sport_male',
          items: [
            {
              title: 'nav.item.female_general_sport',
              href: '/collection/the-thao-chung-nam',
              img: '/image/March2025/mceclip22.png',
            },
            {
              title: 'nav.item.female_running',
              href: '/collection/quan-ao-chay-bo',
              img: '/image/March2025/mceclip18_32.png',
            },
            {
              title: 'nav.item.gym',
              href: '/collection/quan-ao-phu-kien-tap-gym',
              img: '/image/March2025/mceclip19_2.png',
            },
            {
              title: 'nav.item.football',
              href: '/collection/quan-ao-da-bong-coolmate',
              img: '/image/March2025/mceclip16.png',
            },
            {
              title: 'nav.item.male_swimwear',
              href: '/collection/do-boi-nam',
              img: '/image/March2025/mceclip15.png',
            },
            {
              title: 'nav.item.female_badminton',
              href: '/collection/racquet-sports-collection',
              img: '/image/March2025/mceclip17_87.png',
            },
            {
              title: 'nav.item.female_pickleball',
              href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nam',
              img: '/image/June2025/mceclip7.png',
            },
            {
              title: 'nav.item.outdoor',
              href: '/collection/outdoor-collection',
              img: '/image/August2024/mceclip0_18.jpg',
            },
          ],
        },
        {
          title: 'nav.section.sport_female',
          items: [
            {
              title: 'nav.item.female_yoga',
              href: '/collection/yoga-pilates',
              img: '/image/March2025/mceclip14.png',
            },
            {
              title: 'nav.item.female_sport_shirt',
              href: '/collection/ao-nu-choi-the-thao',
              img: '/image/March2025/mceclip9_28.png',
            },
            {
              title: 'nav.item.female_running',
              href: '/collection/quan-ao-chay-bo-nu',
              img: '/image/March2025/mceclip10_72.png',
            },
            {
              title: 'nav.item.female_sport_pants',
              href: '/collection/quan-nu-choi-the-thao',
              img: '/image/March2025/mceclip12_6.png',
            },
            {
              title: 'nav.item.female_general_sport',
              href: '/collection/the-thao-chung-nu',
              img: '/image/March2025/mceclip13_73.png',
            },
            {
              title: 'nav.item.female_sport_accessories',
              href: '/collection/phu-kien-nu-choi-the-thao',
              img: '/image/March2025/mceclip11_21.png',
            },
            {
              title: 'nav.item.female_pickleball',
              href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nu',
              img: '/image/June2025/mceclip6_7.png',
            },
          ],
        },
      ],
      featured: [
        {
          title: 'nav.featured.sport_polo_male',
          href: '/product/ao-polo-the-thao-nam-promax-s1-logo-1?color=nau-coffee-quartz',
          imageAlt: 'nav.featured.sportPoloMale',
          imageSrc: '/uploads/April2025/mceclip6_98.jpg',
        },
        {
          title: 'nav.featured.sport_shorts_male',
          href: '/product/quan-the-thao-nam-promax-s1?color=den',
          imageAlt: 'nav.featured.sportShortsMale',
          imageSrc: '/uploads/April2025/mceclip3_42.jpg',
        },
      ],
    },
  },
  footer: {
    menu: [
      {
        title: 'nav.mobile.footer.coolclub',
        icon: Star,
        className: 'font-bold text-primary-500 [&_svg]:fill-primary-500',
        href: '/coolclub',
      },
      {
        title: 'nav.mobile.footer.cskh',
        href: '/page/trung-tam-dich-vu-khach-hang?itm_source=navbar',
      },
      { title: 'nav.mobile.footer.about', href: '/page/coolmate-story' },
      {
        title: 'nav.mobile.footer.recruit',
        href: '/lp/coolmate-101?itm_source=footer',
      },
      { title: 'nav.mobile.footer.login', href: '/login' },
      { title: 'nav.mobile.footer.blog', href: '/blog' },
    ],
  },
}
